class SimpleLine {
  constructor(el1, el2, options = {}) {
    this.el1 = el1;
    this.el2 = el2;
    // 초기 옵션 설정
    this.color = options.color || "#555";
    this.width = options.width || 2;
    this.type = options.type || "curve";
    this.curviness = options.curviness || 0.5;

    // SVG 컨테이너 및 Path 생성
    this.svg = document.querySelector(".simple-line-svg");
    if (!this.svg) {
      this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      this.svg.classList.add("simple-line-svg");
      document.body.appendChild(this.svg);
    }

    this.path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    this.path.setAttribute("fill", "none");
    this.svg.appendChild(this.path);

    // 초기 스타일 적용 (Path에 SVG 속성 설정)
    this.path.setAttribute("stroke", this.color);
    this.path.setAttribute("stroke-width", this.width);

    this.update();
    // 화면 크기 변경 감지
    window.addEventListener("resize", () => this.update());
    // 문서의 내용물 크기 변경 감지 (p태그 로딩 등 대응)
    // body의 크기가 변할 때마다 선 위치를 재계산합니다.
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(document.body);
  }

  // --- 선 위치 계산 및 그리기 메서드 ---
  update() {
    const r1 = this.el1.getBoundingClientRect();
    const r2 = this.el2.getBoundingClientRect();

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    const startX = r1.right + scrollX;
    const startY = r1.top + r1.height / 2 + scrollY;
    const endX = r2.left + scrollX;
    const endY = r2.top + r2.height / 2 + scrollY;

    let d = "";
    if (this.type === "straight") {
      d = `M ${startX} ${startY} L ${endX} ${endY}`;
    } else {
      const deltaX = Math.abs(endX - startX) * this.curviness;
      d = `M ${startX} ${startY} C ${startX + deltaX} ${startY}, ${endX - deltaX} ${endY}, ${endX} ${endY}`;
    }

    this.path.setAttribute("d", d);
  }

  remove() {
    if (this.path && this.path.parentNode) {
      this.path.parentNode.removeChild(this.path);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
    // Note: window resize listener is still there, might need a way to remove it too if we care about perfection.
    // For now this is better than nothing.
  }
}

export default SimpleLine;
